// deploy on prod  use
export const baseURL = process.env.REACT_APP_PROD_URL;
export const otherBaseURL = process.env.REACT_APP_DATA_SCIENCE_PROD_URL;
export const chatURL = process.env.REACT_APP_CHAT_URL;
export const dataScienceURL = process.env.REACT_APP_PROD_URL;

export const env = process.env.REACT_APP_ENV

console.log(process.env)

// deploy on service use
// export const baseURL = process.env.REACT_APP_DEV_URL
// export const otherBaseURL = process.env.REACT_APP_DATA_SCIENCE_DEV_URL
// export const chatURL = process.env.REACT_APP_CHAT_URL;
// export const dataScienceURL = process.env.REACT_APP_DEV_URL
